var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unbind-box section-white content-padded"},[_c('div',{staticClass:"content-center"},[_c('p',[_vm._v("您尚未绑定认证服务号，无法使用该功能。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toBind}},[_vm._v("去绑定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }